import React from "react";

const Loader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="spinner-border custom-loader" role="status" />
    </div>
  );
};

export default Loader;
